
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-registry-port-label-layout-demo-port-label-layout-side","docs-api-registry-port-label-layout-demo-port-label-layout-inside-outside","docs-api-registry-port-label-layout-demo-port-label-layout-radial"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.zh.md?type=demo')
};